/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Create_Ad_Template_PendingInputs */

const en_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating AD template... please wait...`)
};

const fr_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Création du modèle de description audio... veuillez patienter...`)
};

const de_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Vorlage wird erstellt... Bitte warten...`)
};

const it_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creazione del modello di annuncio... attendere prego...`)
};

const ru_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание шаблона объявления... пожалуйста, подождите...`)
};

const es_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando plantilla de AD... por favor espere...`)
};

const zh_cn2_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在创建广告模板……请稍候……`)
};

const ja_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD テンプレートを作成しています...お待ちください...`)
};

const hi_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD टेम्प्लेट बनाया जा रहा है... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_event_group_options_create_ad_template_pending = /** @type {(inputs: Event_Group_Options_Create_Ad_Template_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando modelo de anúncio... aguarde...`)
};

/**
* | output |
* | --- |
* | "Creating AD template... please wait..." |
*
* @param {Event_Group_Options_Create_Ad_Template_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template_pending = /** @type {((inputs?: Event_Group_Options_Create_Ad_Template_PendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_Template_PendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_create_ad_template_pending(inputs)
	if (locale === "de") return de_event_group_options_create_ad_template_pending(inputs)
	if (locale === "it") return it_event_group_options_create_ad_template_pending(inputs)
	if (locale === "ru") return ru_event_group_options_create_ad_template_pending(inputs)
	if (locale === "es") return es_event_group_options_create_ad_template_pending(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_create_ad_template_pending(inputs)
	if (locale === "ja") return ja_event_group_options_create_ad_template_pending(inputs)
	if (locale === "hi") return hi_event_group_options_create_ad_template_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_create_ad_template_pending(inputs)
	return en_event_group_options_create_ad_template_pending(inputs)
});